import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const Panel = ({ title, aside, children, sx }) => (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 2, p: 2.5, ...sx }}>
        <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: 2 }}>
            <Typography variant="overline" color="text.secondary">{title}</Typography>
            {aside}
        </Stack>
        {children}
    </Box>
);

export default Panel;
